import { useDispatch, useSelector } from "react-redux";
import { updateCurrency } from "../store/slice/config";

const useCurrency = () => {
  const dispatch = useDispatch();
  const { currency } = useSelector((state) => state.config);

  const setCurrency = (value) => {
    dispatch(updateCurrency(value));
    window.location.reload();
  };

  return [currency, setCurrency];
};

export default useCurrency;
